import React from 'react';
import { useRouter } from 'next/router';
import icons from '../../shared/assets/icons/redesign';

const { Check } = icons;

export default function CoursesBuyPopup({ showPopup }) {
  const router = useRouter();

  return (
    <div className="coursesPopup-wrap">
      <div className="coursesPopup">
        <div className="coursesPopup-header">
          <h3 className="coursesPopup-header-title">Kopen</h3>

          <span
            className="coursesPopup-close-button"
            onClick={() => showPopup(false)}
          >
            &times;
          </span>
        </div>

        <div className="coursesPopup-body">
          <h4 className="coursesPopup-body-title">
            Om dit item te bekijken heb je toegang nodig tot cursussen.
          </h4>

          <ul className="coursesPopup-body-list">
            <li className="coursesPopup-body-list-item">
              <div className="coursesPopup-body-list-item-icon-wrap">
                <Check className="coursesPopup-body-list-item-icon" />
              </div>
              18 maanden onbeperkt toegang tot 10 online cursussen
            </li>

            <li className="coursesPopup-body-list-item">
              <div className="coursesPopup-body-list-item-icon-wrap">
                <Check className="coursesPopup-body-list-item-icon" />
              </div>
              Afgestemd op je zwangerschap, bevalling,
              de babytijd en je partner
            </li>

            <li className="coursesPopup-body-list-item">
              <div className="coursesPopup-body-list-item-icon-wrap">
                <Check className="coursesPopup-body-list-item-icon" />
              </div>
              Gratis, afhankelijk van je verzekering. Anders maar
              99,99 euro voor het hele pakket
            </li>

            <li className="coursesPopup-body-list-item">
              <div className="coursesPopup-body-list-item-icon-wrap">
                <Check className="coursesPopup-body-list-item-icon" />
              </div>
              Meer dan 100 video’s en 1000+ minuten materiaal
            </li>
          </ul>

          <button
            onClick={() => showPopup(false)}
            className="coursesPopup-button coursesPopup-button-secondary"
          >
            Misschien later
          </button>

          <button
            onClick={() =>
              (router.push('/zwangerschapscursus/welkom'), showPopup(false))}
            className="
              coursesPopup-button
              coursesPopup-button-primary
              coursesPopup-button-default
            "
          >
            Kopen
          </button>
        </div>
      </div>
    </div>
  );
}
